import { REACT_APP_GROWSARI_GRAPHQL_URI, REACT_APP_GROWCUBE_GQL_API } from "config";

const DEFAULT_GQL_URI = REACT_APP_GROWSARI_GRAPHQL_URI;
const GROWCUBE_GQL_URI = REACT_APP_GROWCUBE_GQL_API;

export { DEFAULT_GQL_URI, GROWCUBE_GQL_URI };
